import { type CarouselNavPagerDotProps } from '@jouzen/ecom-components/v4/Carousel';

import Motion, { type MotionProps } from '@/app/components/Motion';

const INACTIVE_WIDTH = 6;
const ACTIVE_WIDTH = 36;

export const getWrapperMotionProps = ({
  isActive,
  transitionDuration,
}: {
  isActive: boolean;
  transitionDuration: number;
}): MotionProps => ({
  animate: {
    width: isActive ? ACTIVE_WIDTH : INACTIVE_WIDTH,
  },
  initial: {
    width: isActive ? ACTIVE_WIDTH : INACTIVE_WIDTH,
  },
  transition: {
    duration: transitionDuration,
    type: 'tween',
  },
});

export const getInnerMotionProps = ({
  isActive,
  isAutoplaying,
  transitionDuration,
}: {
  isActive: boolean;
  isAutoplaying: boolean;
  transitionDuration: number;
}): MotionProps => ({
  animate: {
    x: !isActive && isAutoplaying ? -(ACTIVE_WIDTH - INACTIVE_WIDTH) : 0,
  },
  initial: {
    x: isAutoplaying ? -(ACTIVE_WIDTH - INACTIVE_WIDTH) : 0,
  },
  transition: {
    duration: isActive ? transitionDuration : 0,
    type: 'tween',
  },
});

const HeroCarouselNavPagerDot = ({
  interval,
  isActive,
  isAutoplaying,
  transitionDuration,
}: CarouselNavPagerDotProps) => {
  return (
    <Motion
      className="relative block h-1.5 overflow-hidden rounded-[15px] bg-sandstone-200/40"
      el="span"
      {...getWrapperMotionProps({ isActive, transitionDuration })}
    >
      <Motion
        className="absolute top-0 left-0 block h-full w-9 origin-left rounded-[15px] bg-sandstone-200"
        el="span"
        {...getInnerMotionProps({
          isActive,
          isAutoplaying,
          transitionDuration: interval,
        })}
      />
    </Motion>
  );
};

export default HeroCarouselNavPagerDot;
